import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m16.184 8.496-3.282 3.281 3.254 3.254a.6.6 0 0 1 0 .903.6.6 0 0 1-.902 0l-3.281-3.254-3.254 3.254a.6.6 0 0 1-.903 0c-.273-.246-.273-.657 0-.93l3.254-3.254-3.254-3.254c-.273-.246-.273-.656 0-.93.247-.246.657-.246.93 0L12 10.848l3.254-3.254c.246-.274.656-.274.93 0a.644.644 0 0 1 0 .902"
    }, null, -1)
  ]))]))
}
export default { render: render }